module.exports = __webpack_public_path__ + "media/ad_preview/verge-f1370e81.png";